import * as CONST from "./actionTypes";

const intialState = {
  categories: [],
  error: null,
  loading: false,
};

const CategoryReducer = (state = intialState, { type, payload }) => {
  switch (type) {
    case CONST.CATEGORY_LIST:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case CONST.CATEGORY_LIST_SUCCESS:
      return {
        ...state,
        categories: payload,
        error: null,
        loading: false,
      };
    case CONST.CATEGORY_LIST_FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    /* >>>>>>>>>>>>>> EDIT CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.EDIT_CATEGORY:
      return {
        ...state,
        error: null,
      };
    case CONST.EDIT_CATEGORY_SUCCESS:
      return {
        ...state,
        categories: payload,
        error: null,
      };
    case CONST.EDIT_CATEGORY_FAIL:
      return {
        ...state,
        error: payload,
      };
    /* >>>>>>>>>>>>>> UPDATE CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.UPDATE_CATEGORY:
      return {
        ...state,
        error: null,
      };
    case CONST.UPDATE_CATEGORY_SUCCESS:
      return {
        ...state,
        categories: { ...payload },
        error: null,
      };
    case CONST.UPDATE_CATEGORY_FAIL:
      return {
        ...state,
        error: payload,
      };
    /* >>>>>>>>>>>>>> ADD CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.ADD_CATEGORY:
      return {
        ...state,
        error: null,
      };
    case CONST.ADD_CATEGORY_SUCCESS:
      return {
        ...state,
        categories: { ...payload },
        error: null,
      };
    case CONST.ADD_CATEGORY_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> DELETE CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.DELETE_CATEGORY:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETE_CATEGORY_SUCCESS:
      return {
        ...state,
        categories: payload,
        error: null,
      };
    case CONST.DELETE_CATEGORY_FAIL:
      return {
        ...state,
        error: payload,
      };

    default:
      return state;

      break;
  }
};

export default CategoryReducer;
